import React, { useState } from 'react';
import { useAuth } from '../../auth/auth-hook';
import { UserInvitation, UserInvitationStatuses, useUserInvitationsQuery } from '../../../shared/types/generated';
import { DialogDefault } from '../../../shared/components/dialog/DialogDefault';
import { TenantUserInvitationItem } from './TenantUserInvitationItem';

export const Invitations: React.FC = () => {
  const [isOpen, setOpen] = useState(false);
  const { user } = useAuth();

  console.log({ user });
  const { data } = useUserInvitationsQuery({
    variables: {
      data: {
      where: {
        email: user?.email,
        status: UserInvitationStatuses.Pending,
      },
    },
    },
    onCompleted: ({ userInvitations }) => {
      if (userInvitations?.items?.length) setOpen(true);
    },
  });
  const invitations = (data?.userInvitations?.items ||
    []) as UserInvitation[];

  return (
    <DialogDefault title={'INVITACIONES PENDIENTES'} isOpen={isOpen}>
      {invitations.map((invitation) => (
        <TenantUserInvitationItem item={invitation} />
      ))}
    </DialogDefault>
  );
};
